import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/components/_v2/redux/storeMain";
import { ComponentTypes } from "../../../src/taskpane/config/config";
import { SharePointFolderContentTypeIds } from "../../../src/taskpane/config/constants";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { PreviewLink20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/PreviewLink20Regular";

export function useMenuItem_Preview(selectedItems: any[], setIsCMFilePreviewPanelOpen: (isCMFilePreviewPanelOpen: boolean) => void) {
    const languageStrings = React.useContext(LanguageContext);

    const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);

    const { menuItem_Preview, menuItem_Preview_IconOnly } = React.useMemo(() => {
        if (selectedItems?.length === 1 && !selectedItems[0].ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder) && currentDirectory.type !== ComponentTypes.SharePointList) {
            const menuItem_Preview: IContextualMenuItem =
            {
                key: 'preview',
                name: languageStrings.ShowPreview,
                // iconProps: { iconName: "PreviewLink" },
                iconProps: {},
                onRenderIcon: () => <PreviewLink20Regular className={menuItemIconStyles} />,
                onClick: () => {
                    setIsCMFilePreviewPanelOpen(true);
                }
            };

            const menuItem_Preview_IconOnly: IContextualMenuItem = {
                key: "previewIconOnly",
                // iconProps: { iconName: "PreviewLink" },
                iconProps: {},
                onRenderIcon: () => <PreviewLink20Regular className={menuItemIconStyles} />,
                iconOnly: true,
                tooltipHostProps: {
                    content: <span>{languageStrings.ShowPreview}</span>
                },
                onClick: () => {
                    setIsCMFilePreviewPanelOpen(true);
                }
            }

            return { menuItem_Preview, menuItem_Preview_IconOnly };
        }

        return { menuItem_Preview: null, menuItem_Preview_IconOnly: null };
    }, [selectedItems, currentDirectory, languageStrings, setIsCMFilePreviewPanelOpen]);

    return {
        menuItem_Preview,
        menuItem_Preview_IconOnly
    }
}